import { useRef, useEffect } from 'react';
import TimelineItem from './TimelineItem';
import './Timeline.scss';

export default function Experience() {
  const experiences = [{
    title: "Aegon",
    start: "Jan 2022",
    end: null,
    description: `Started as part of the team that is responsible for the development and maintenance of the design system of Aegon and provided support and onboarding sessions to teams that make use of it. 
      Later on, also took part in maintaining the consumer portal Mijn Aegon and helped with the decommissioning of various frontend applications.`,
    skills: ["HTML", "TypeScript", "Angular", 'Storybook']
  },
  {
    title: "Vanderlande",
    start: "Nov 2021",
    end: "Jan 2022",
    description: "Took part in the development of an application that visualizes the baggage sorting systems of various airports in order to analyze the flow of baggage and help identify potential issues.",
    skills: ["HTML", "TypeScript", "Angular", 'D3.js']
  },
  {
    title: "Cegeka",
    start: "Apr 2020",
    end: "Jan 2022",
    description: `Worked as a frontend development consultant for customers such as Schiphol and KPN Data Services Hub.`,
    skills: ["HTML", "TypeScript", "React", 'SPFx']
  },
  {
    title: "KPN",
    start: "Dec 2019",
    end: "Nov 2021",
    description: `Developed multiple visualizations of streaming data coming from the Data Services Hub using React, Node.js and KafkaJS.
    Those visualizations were used to demonstrate to customers what the data platform of the KPN's Data Services Hub can provide for them. 
    Also maintained a documentation page for the platform.`,
    skills: ["HTML", "React", "Leaflet.js", "D3.js", "Docker", "Node.js", 'KafkaJS']
  },
  {
    title: "Royal Schiphol Group",
    start: "Feb 2019",
    end: "Nov 2021",
    description: "Developed multiple React applications for Microsoft SharePoint Online using the SharePoint Framework (SPFx), to be used by Schiphol employees. Delivered a brand new, modern intranet where employees can find news, events, documents and more.",
    skills: ["HTML", "TypeScript", "React", 'SPFx', "Microsoft Sharepoint Online"]
  },
  {
    title: "KPN ICT Consulting",
    start: "Jul 2018",
    end: "Apr 2020",
    description: "Worked as part of the scrum team that developed Explore, an application used within KPN ICT Consulting for looking up colleagues and project offers.",
    skills: ["HTML", "TypeScript", "Angular"]
  },
  {
    title: "T-Mobile",
    start: "Mar 2016",
    end: "Jun 2018",
    description: "As a frontend developer I took part in the development of T-Mobile's new online shop, the redesign of the website, and the development of a custom CMS editing tool.",
    skills: ["HTML", "SCSS", "TypeScript", "Angular", 'Vue.js', "ASP.NET"]
  },
  {
    title: "Competa",
    start: "Feb 2015",
    end: "Jun 2018",
    description: `Worked as a front-end developer and took part in various projects during which I've drastically improved my skills and learned a number of new frameworks such as AngularJS and tools like Grunt. 
    Among the projects that I've worked on were the creation of a To-Do List application with AngularJS, 
    the changing of the design and functionality of a website called 101kantoren, and the development of a website for a company called Fair Source, which is a provider of Fair Trade software.`,
    skills: ["HTML", "SCSS", "Angular"]
  }];

  const timelineAnimationRef = useRef();
  const timelineRef = useRef();

  useEffect(() => {
    const handleScroll = (event) => {
      if (timelineRef.current.offsetTop <= window.scrollY + window.innerHeight / 2 && window.scrollY + window.innerHeight / 2 < timelineRef.current.offsetTop + timelineRef.current.clientHeight) {
        timelineAnimationRef.current.style.height = (window.scrollY + window.innerHeight / 2) - timelineRef.current.offsetTop + "px";
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="timeline" ref={timelineRef}>
      <div className="animated-timeline" ref={timelineAnimationRef}></div>
      {experiences.map((experience) => (
        <TimelineItem timelineRef={timelineRef} experience={experience}></TimelineItem>
      ))}
    </div>
  );
}